import React, { createContext, useState, useEffect, useContext, useRef } from "react";
import { subscribeSocketApi } from "../api/request/dashboard/dashboard";
import { getCookies } from "../services/Cookies";
import { useDispatch, useSelector } from "react-redux"
import { addEmail, deleteEmail } from "../store/Slices/emailsSlice";
import { setAccountSummary } from '../store/Slices/accountSummary'
import { saveAlertData, updateAlertData, deleteAlertData } from '../store/Slices/alertSlice';
import { addOrdersData, deleteOrdersData, deletePositionsData, addPositionsData, updateOrdersData, updatePositionData, deleteSLTPOrder, editSLTPOrder, addSLTPOrder, setAccountHistoryData, addAccountHistoryData, removeAccountHistoryData, updateAccountHistoryData } from '../store/Slices/orderPositionSlice';
import { fetchAccountTree } from "../store/thunks/accountSummary";
import { publishNewTick } from "../components/charts/RealtimeTrdingChart";
import { addNewClient, updateClient, deleteClient, updateAccount, deleteAccount } from '../store/Slices/accountTree'
import toast from "react-hot-toast";
import { fetchSymbols } from '../store/thunks/watchlist'
import { fetchAccountHistory, fetchAllPositions } from "../store/thunks/orders";
import { fetchAllSymbolParams } from "../store/thunks/symbolGroup";
import { deletePLValue } from "../components/footer/AccountFooter";
import { updateProfitLoss } from "../store/Slices/profitLossSlice";
import useWebSocket from "react-use-websocket";
import { updateSymbols } from "../store/Slices/updateSymbol";
import { showPriceChangeDialog } from "../store/Slices/priceChange";
import { addJournalLog } from "../components/tab/tabview/journal/addJournalLog";
const WebSocketContext = createContext(null);


export const symbolMap = new Map();

export const WebSocketProvider = ({ children }) => {
  const token = getCookies("token");
  const [socketUrl, setSocketUrl] = useState(`${process.env.REACT_APP_BASE_URL_WS}/ws?Authorization=${token}`)
  const allSymbolParams = useSelector((state) => state.symbol.allSymbolParams);
  const { symbols } = useSelector(state => state?.watchlist)
  const dispatch = useDispatch();
  const { accountId } = useSelector(state => state.accountSummary);
  const dataRef = useRef({});
  const username = getCookies('username')
  const { lastJsonMessage, readyState, getWebSocket } = useWebSocket(socketUrl, {
    onOpen: () => subscribeSocket(),
    onClose: () => console.log("❌ WebSocket Disconnected"),
    shouldReconnect: () => true, // Auto-reconnect on failure
  })

  useEffect(() => {
    if (lastJsonMessage?.eventType !== undefined) {
      const { value } = lastJsonMessage;
      switch (lastJsonMessage.eventType) {
        case 0: if (dataRef?.current) {
          value?.forEach((update) => {
            const newBid = update.bid + (allSymbolParams?.[update?.symbolID]?.spreadBidBalance * (1 / Math.pow(10, dataRef?.current?.[update?.symbolID]?.digits)))
            const newAsk = update.ask + (allSymbolParams?.[update?.symbolID]?.spreadAskBalance * (1 / Math.pow(10, dataRef?.current?.[update?.symbolID]?.digits)))
            const fixedBidPower = allSymbolParams?.[update?.symbolID]?.spreadValue * (1 / Math.pow(10, dataRef?.current?.[update?.symbolID]?.digits))
            dataRef.current[update?.symbolID] = {
              ...dataRef.current[update?.symbolID],
              ...update,
              ...(dataRef.current?.[update?.symbolID]?.bid > update?.bid ? { bidColor: 'down' } : { bidColor: 'up' }),
              ...(dataRef.current?.[update?.symbolID]?.ask > update?.ask ? { askColor: 'down' } : { askColor: 'up' }),
              bid: newBid,
              ask: allSymbolParams?.[update?.symbolID]?.spreadType == 0 ? newBid + fixedBidPower : newAsk,
            }
            publishNewTick({ ...dataRef.current?.[update?.symbolID], ts: Date.now() }, "", update.symbolID)
          })
          dispatch(updateSymbols({ ...dataRef.current }))
        };
          break;
        case 1:
          addPosition(value);
          dispatch(removeAccountHistoryData({id: value.id }))
          addJournalLog('tradeOpened', `Trade opened: ID #${value.id}, ${value.symbolName}, at ${value.openPrice}, ${value.side === 1 ? "Buy" : "Sell"}, Amount: ${value.amount}, Account ${username}: ${accountId}.`);
          break;
        case 2:
          deletePoisitions(value);
          // dispatch(fetchAccountHistory(accountId))
          break;
        case 3:
          // dispatch(removeAccountHistoryData(value))
          updatePosition(value);
          break;
        case 4:
          addSLTPOrderData(value);
          break;
        case 5:
          editSLTPOrderData(value);
          break;
        case 6:
          deleteSLTPOrderData(value);
          break;
        case 7:
          // marketOrder(value);
          addPendingOrder(value);
          addJournalLog('marketOrderPlaced', `Market order placed: ${value.symbolName}, Amount: ${value.amount}, Account ${username}: ${accountId}.`);
          break;
        case 8:
          updatePendingOrder(value);
          break;
        case 9:
          // deleteMarketOrder(value);
          deletePendingOrder(value);
          break;
        case 10:
          deletePendingOrder(value);
          break;
        case 11:
          addPendingOrder(value);
          break;
        case 12:
          updatePendingOrder(value);
          break;
        case 13:
          deletePendingOrder(value);
          break;
        case 14:
          updateAccountSummary(value);
          break;
        case 15:
          addMail(value);
          break;
        case 16:
          deleteMail(value);
          break;
        case 17:
          saveAlert(value);
          break;
        case 18:
          editAlert(value);
          break;
        case 19:
          deleteAlert(value);
          break;
        case 20:
          addJournalLog('deliveryOrderPlaced', `Delivery order placed: ${value.symbolName}, Amount: ${value.amount}, Account ${username}: ${accountId}.`);
          break;
        case 26:
          addAccountData(value);
          break;
        case 27:
          updateAccountData(value);
          break;
        case 28:
          deleteAccountData(value);
          break;
        case 29:
          addNewSymbolData(value);
          break;
        case 30:
          updateSymbolData(value);
          break;
        case 31:
          deleteSymbolData(value);
          break;
        case 32:
          addClientData(value);
          break;
        case 33:
          editClientData(value);
          break;
        case 34:
          deleteClientData(value);
          break;
        case 35:
          toast.success("Your account has been liquidated");
          break;
        case 37:
          dispatch(fetchAllSymbolParams());
          break;
        case 40:
          dispatch(addAccountHistoryData(value));
          dispatch(updateAccountHistoryData(value));
          // dispatch(fetchAccountHistory(accountId))
          break;
        case 41:
          dispatch(showPriceChangeDialog(value))
          break;

        default:
          console.warn(``);
      }
    }
  }, [lastJsonMessage])


  const subscribeSocket = async (accountId, fromAccount) => {
    try {
      // if (fromAccount) await unsubscribeSocketApi();
      console.log("readyState", readyState);
      console.log('accountId', accountId)
      if (readyState == 1) {
        // console.log(accountId)
        const { data } = await subscribeSocketApi(accountId);
      }
    } catch (err) {
      console.log("error from subscribe", err.message)
    }
  }

  useEffect(() => {
    console.log("accountId", accountId)
    if (accountId) {
      // if (readyState == 1) {
      subscribeSocket(accountId, true)
      // }
    }
  }, [accountId, readyState])

  useEffect(() => {
    const token = getCookies("token");
    setSocketUrl(`${process.env.REACT_APP_BASE_URL_WS}/ws?Authorization=${token}`)
  }, [token])

  useEffect(() => {
    // setSymbolPrices({ ...symbols })
    dataRef.current = { ...symbols }
    dispatch(updateSymbols({ ...symbols }))
  }, [symbols])


  const addPosition = async (data) => {
    dispatch(addPositionsData(data))
    toast.success(`Trade opened: ID #${data.id} , ${symbols[data.symbolId].name} ${data.side == 1 ? 'Buy' : 'Sell'} at ${data.openPrice}, Amount: ${data.amount}`);
    addJournalLog('marketOrderPlaced', `Market order placed: ${symbols[data.symbolId].name}, Amount: ${data.amount}, Account ${username}: ${accountId}.`);
  }

  const updatePosition = async (data) => {
    dispatch(updatePositionData(data))
    // dispatch(removeAccountHistoryData(data))
    toast.success(`Trade updated: ID #${data?.id} ${symbols[data.symbolId].name} at ${data.openPrice}, Amount: ${data.amount}`);
    addJournalLog('updatedPosition', `Position #${data.id} has been updated, Account ${username}: ${accountId}.`);
  }

  const deletePoisitions = async (data) => {
    deletePLValue(data)
    dispatch(updateProfitLoss());
    dispatch(deletePositionsData(data))
    toast.success(`Closed Trade #${data}`);
    // toast.success(`Closed Trade #${data.id} (${symbols[data.symbolId].name}) at ${data.openPrice}, ${data.side == 1 ? 'Buy' : 'Sell'}, P/L ${data.profitLoss}`);
    addJournalLog('deletedPosition', `Position #${data} has been deleted, Account ${username}: ${accountId}.`);
    // dispatch(setAccountHistoryData(data))
  }

  const addPendingOrder = async (data) => {
    dispatch(addOrdersData(data))
    toast.success(`Order: ID #${data.id} , ${symbols[data.symbolId].name} ${data.side == 1 ? 'Buy' : 'Sell'} at ${data.price}, Amount: ${data.amount}`);

  }

  const updatePendingOrder = async (data) => {
    toast.success(`Order updated: ID #${data?.id} ${symbols[data.symbolId].name} at ${data.price}, Amount: ${data.amount}`);
    dispatch(updateOrdersData(data))
  }

  const deletePendingOrder = async (data) => {
    dispatch(deleteOrdersData(data))
    toast.success(`Order #${data} has been canceled successfully.`);
  }

  const updateAccountSummary = async (data) => {
    dispatch(setAccountSummary(data))
  }
  const deleteSLTPOrderData = async (data) => {
    toast.success(`SLTP #${data} deleted successfully`);
    deletePLValue(data)
    dispatch(updateProfitLoss());
    dispatch(deleteSLTPOrder(data))
  }
  const editSLTPOrderData = async (data) => {
    dispatch(editSLTPOrder(data))
    toast.success(`SLTP #${data.id} updated successfully`);
    addJournalLog('updatedManageOrder', `Pending order #${data.id} has been updated, Account ${username}: ${accountId}`);
  }
  const addSLTPOrderData = async (data) => {
    dispatch(addSLTPOrder(data))
    toast.success(`SLTP order #${data.id} at ${data.amount} placed successfully`)
    addJournalLog('createdManageOrder', `Pending order #${data.id} has been created, ${data.symbolName}, ${data.side === 1 ? "Buy" : "Sell"}, Amount: ${data.amount}, SL ${data.stopLoss ?? '0.00'}, TP ${data.takeProfit ?? '0.00'} Account ${username}: ${data.accountId}.`);
  }
  const deleteAlert = async (data) => {
    toast.success(`Alert #${data} deleted successfully!`);
    dispatch(deleteAlertData(data))
  }
  const editAlert = async (data) => {
    toast.success(`Alert #${data.id} updated successfully!`);
    dispatch(updateAlertData(data))
  }
  const saveAlert = async (data) => {
    toast.success(`Alert #${data.id} created successfully!`);
    dispatch(saveAlertData(data))
  }
  const addMail = async (data) => {
    toast.success(`New mail received.`)
    dispatch(addEmail(data))
  }
  const deleteMail = async (data) => {
    toast.success(`Mail #${data} deleted successfully!`)
    dispatch(deleteEmail(data))
  }
  const addClientData = async (data) => {
    dispatch(addNewClient(data))
  }
  const editClientData = async (data) => {
    dispatch(updateClient(data))
  }
  const deleteClientData = async (data) => {
    dispatch(deleteClient(data))
  }
  const addNewSymbolData = async (data) => {
    // dispatch(addNewSymbol(data))
    dispatch(fetchSymbols())
  }
  const updateSymbolData = async (data) => {
    // dispatch(updateSymbol(data))
    dispatch(fetchSymbols())
  }
  const deleteSymbolData = async (data) => {
    // dispatch(deleteSymbol(data))
    dispatch(fetchSymbols())
  }
  const setAccountHistory = async (data) => {
    dispatch(setAccountHistoryData(data))
  }
  const addAccountData = async (data) => {
    // dispatch(addNewAccount(data))
    dispatch(fetchAccountTree({ newAccount: true }))
  }
  const updateAccountData = async (data) => {
    dispatch(updateAccount(data))
  }
  const deleteAccountData = async (data) => {
    dispatch(deleteAccount(data))
  }
  const marketOrder = async (data) => {
    fetchAllPositions()
  }
  const deleteMarketOrder = async (data) => {
    fetchAllPositions()
  }

  return (
    <WebSocketContext.Provider value={{}} >
      {children}
    </WebSocketContext.Provider>
  );
};

export const useSymbolPrices = () => useContext(WebSocketContext);
